import React from 'react';
import { useParams, Link } from 'react-router-dom';
import useTimetable from '../hooks/useTimetable';

function TimetableView() {
  const { routeId } = useParams();
  const { routeInfo, directions, directionId, setDirectionId, timetable, loading, error } = useTimetable(routeId);

  const currentHour = new Date().getHours();

  return (
    <div className="timetable-container">
      <Link to="/rozklad" className="back-button">
        ← Powrót do listy linii
      </Link>

      {/* Header */}
      {routeInfo && (
        <div className="timetable-header">
          <span className={`line-badge line-badge--large ${routeInfo.routeType === 'TRAM' ? 'line-badge--tram' : ''}`}>
            {routeInfo.routeShortName}
          </span>
          <div className="timetable-route-name">{routeInfo.routeLongName}</div>
        </div>
      )}

      {/* Direction tabs */}
      {directions.length > 1 && (
        <div className="direction-tabs">
          {directions.map((dir) => (
            <button
              key={dir.directionId}
              className={`direction-tab ${dir.directionId === directionId ? 'direction-tab--active' : ''}`}
              onClick={() => setDirectionId(dir.directionId)}
            >
              {dir.headsign}
            </button>
          ))}
        </div>
      )}

      {/* Single direction label */}
      {directions.length === 1 && (
        <div className="timetable-direction-label">
          Kierunek: <strong>{directions[0].headsign}</strong>
        </div>
      )}

      {/* Content */}
      {loading && <div className="loading">Ładowanie rozkładu jazdy...</div>}
      {error && <div className="error">{error}</div>}

      {!loading && !error && timetable && timetable.stops.length === 0 && (
        <div className="no-departures">Brak danych rozkładowych dla tej linii.</div>
      )}

      {!loading && !error && timetable && timetable.stops.length > 0 && (
        <div className="timetable-scroll">
          <table className="timetable">
            <thead>
              <tr>
                <th className="stop-name-cell">Przystanek</th>
                {timetable.hours.map((hour) => (
                  <th
                    key={hour}
                    className={hour === currentHour ? 'current-hour' : ''}
                  >
                    {String(hour).padStart(2, '0')}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {timetable.stops.map((stop) => (
                <tr key={`${stop.stopId}-${stop.stopSequence}`}>
                  <td className="stop-name-cell">
                    <Link to={`/stop/${stop.stopId}`} className="timetable-stop-link">
                      {stop.stopName}
                    </Link>
                  </td>
                  {timetable.hours.map((hour) => {
                    const minutes = timetable.grid[stop.stopId]?.[hour];
                    return (
                      <td
                        key={hour}
                        className={`minute-cell ${hour === currentHour ? 'current-hour' : ''}`}
                      >
                        {minutes && minutes.length > 0
                          ? minutes.map(m => String(m).padStart(2, '0')).join(' ')
                          : ''}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default TimetableView;
